var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('List',{attrs:{"title":"View Servers"},on:{"read":function($event){return _vm.load()}}},_vm._l((_vm.servers),function(server){return _c('ServerCard',{key:server._id,attrs:{"id":server._id}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }